import { User } from "@models";
import { useStore } from "@stores";
import { useEffect } from "react";

export const useUser = (id: string | undefined): User | undefined => {
  const { userStore } = useStore();
  const { user } = userStore;

  useEffect(() => {
    id && userStore.getProfile();

    return () => userStore.resetUser();
  }, [id, userStore]);

  return user;
};
